import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Products, TranslationService } from 'gast-common-ng2';
import { ClozeTestStyleModel } from 'gast-onset-ng2';
import { CommonPortalUrlService } from 'gast-portal-ng2';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UrlService } from '../../shared/services/common/url.service';

@Component({
  selector: 'app-onset-study-home',
  templateUrl: './onset-study-home.component.html',
  styleUrls: ['./onset-study-home.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class OnsetStudyHomeComponent implements OnInit, OnDestroy {
  readonly #deviceService = inject(DeviceDetectorService);
  readonly commonPortalUrlService = inject(CommonPortalUrlService);
  readonly #urlService = inject(UrlService);
  readonly translationService = inject(TranslationService);
  readonly #route = inject(ActivatedRoute);
  readonly #router = inject(Router);

  mobileMode = signal(false);

  lang = signal('DE');

  cTestLogo = signal('');
  clozeTestStyleModel = signal<ClozeTestStyleModel | null>({} as ClozeTestStyleModel);

  username = signal('');
  enoughMobileParticipant = signal(false); // 100 is cut off
  cTestButtonColor = signal('');

  intervalId = signal<any>(null);

  ngOnDestroy(): void {
    clearInterval(this.intervalId());
  }

  ngOnInit() {
    // detect mobile
    this.mobileMode.set(this.#deviceService.isMobile());
    this.clozeTestStyleModel.set(this.#generateClozeTestStyle());
    this.cTestButtonColor.set(this.clozeTestStyleModel()!.onsetColor);
    // sett logo and button color
    this.cTestLogo.set('onset-assets/img/onset_logo.png');

    // handle language
    this.#route.queryParams.subscribe(params => {
      if (params['lang']) {
        const lang = params['lang'].toLocaleLowerCase();
        this.lang.set(lang.toLocaleUpperCase());
        this.changeLanguage(lang);
      }
    });
  }

  changeLanguage(lang: string) {
    this.translationService.changeLanguageUsingCode(lang);
    this.#router.navigate(
      [],
      {
        relativeTo: this.#route,
        queryParams: { lang: lang.toLocaleLowerCase() },
        queryParamsHandling: 'merge'
      });
  }

  login(): void {
    window.location.href = this.commonPortalUrlService.getPortalAccountLoginUrl(
      Products.ONSET, this.translationService, this.#urlService.onSETPortalExamUrl() + 'onset-study');
  }

  register(): void {
    window.location.href = this.commonPortalUrlService.getPortalAccountRegisterUrl(
      Products.ONSET, this.translationService, this.#urlService.onSETPortalExamUrl() + 'onset-study');
  }

  #generateClozeTestStyle(): ClozeTestStyleModel {
    // TODO config
    const model = {} as ClozeTestStyleModel;
    model.siteBackground = '#ffffff';
    model.exerciseBackground = '#EEF3F8';
    model.frameColor = '#92aac1';
    model.barColor = '#b3c9de';
    model.specialCharacterListColor = '#b3c9de';
    model.specialChcaracterTextColor = '#000000';
    model.exerciseTextColor = '#000000';
    model.buttonsColor = '#fa9463';
    model.testdafColor = '#57a7d6';
    model.onsetColor = '#a5d8db';
    model.duoColor = '#ed6a5b';
    model.testasColor = '#fac075';
    model.font = 'arial, helvetica, sans-serif';
    model.fontSize = '11pt';
    model.displayLogo = true;
    model.cTestInformationUrl = 'http://www.wikipedia.com/';
    return model;
  }
}
